document.addEventListener('DOMContentLoaded', function () {
  const wrappers = document.querySelectorAll('[data-ps-media-wrapper]');
  if (!wrappers.length) return;

  wrappers.forEach(function (wrapper) {
    const featured = wrapper.querySelector('[data-ps-featured-media]');
    const thumbs = wrapper.querySelectorAll('.ps-media-thumb');

    if (!featured || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        const mediaElement = this.querySelector('.shopify-product-media, img, video, model-viewer');
        if (!mediaElement) return;

        // Replace featured media content
        featured.innerHTML = '';
        featured.appendChild(mediaElement.cloneNode(true));

        // Update active state
        thumbs.forEach(function (t) {
          t.classList.remove('is-active');
        });
        this.classList.add('is-active');
      });
    });
  });
});
